import React from "react";
import {
  getPhoneConversationTurns,
  roleLabelForTurn,
} from "../../utils/aiHiringInterviewUtils";

export default function PhoneInterviewDetailsSection({ candidate }) {
  const turns = getPhoneConversationTurns(candidate);

  if (!turns.length) {
    return (
      <div className="ai-muted">
        Full conversation will appear here after the phone interview is
        completed.
      </div>
    );
  }

  return (
    <div className="ai-conversation-thread">
      {turns.map((turn, index) => {
        const isAi = turn.role === "ai" || turn.role === "system";
        return (
          <div
            key={`${turn.role}-${index}`}
            className={`ai-conversation-row ${isAi ? "ai-conversation-row--ai" : "ai-conversation-row--applicant"}`}
          >
            <div
              className={`ai-conversation-bubble ${isAi ? "ai-conversation-bubble--ai" : "ai-conversation-bubble--applicant"}`}
            >
              <div className="ai-conversation-speaker">
                {turn.label || roleLabelForTurn(turn.role)}
              </div>
              <div className="ai-conversation-text">{turn.text}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
